// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"cd93e0e6","361":"d10c09fb","391":"445b104a","453":"8ab44547","543":"1e4b825c","599":"20b4f4a7","673":"db1e3308","858":"43ff9973"}[chunkId] + ".chunk.js";
};